<template>
  <div>
    <MainTitle title="Mapas" description="Sistemas de información geográfica y análisis espacial" />
    <div class="container m-y">
      <MapaPrincipalesCultivos />
    </div>
    <div class="container m-y">
      <MapaUsoMaquinaria />
    </div>
    <div class="container m-y">
      <MapaUsoHerbicidas />
    </div>
    <div class="container m-y">
      <MapaRendiemeintoCultivos />
    </div>
  </div>
</template>

<script>
import '@/components/mapas/mapas.scss';
import MainTitle from '@/components/MainTitle.vue';
import MapaPrincipalesCultivos from "@/components/mapas/MapaPrincipalesCultivos.vue";
import MapaUsoMaquinaria from "@/components/mapas/MapaUsoMaquinaria.vue";
import MapaUsoHerbicidas from '@/components/mapas/MapaUsoHerbicidas.vue';
import MapaRendiemeintoCultivos from '@/components/mapas/MapaRendiemeintoCultivos.vue';

export default {
  components: {
    MainTitle,
    MapaPrincipalesCultivos,
    MapaUsoMaquinaria,
    MapaUsoHerbicidas,
    MapaRendiemeintoCultivos,
  }
};
</script>

<style lang="scss">
// @import "~leaflet/dist/leaflet.css";
// @import "~leaflet-responsive-popup/leaflet.responsive.popup.css";


// .mapa-container {
//   height: 80vh;
//   position: relative;
//   box-sizing: border-box;
//   * {
//     box-sizing: border-box;
//   }
//   @media (min-width:$breackpoint-map) {
//     height: 75vh;
//   }
// }

// .mapa-header {
//   background: $gris;
//   color: #fff;
//   padding: 10px;
//   position: absolute;
//   top: 0;
//   width: 100%;
//   z-index: 1004;
//   h2 {
//     font-size: 14px;
//     line-height: 1.3em;
//     margin: 0;
//     padding: 0;
//   }
//   p {
//     display: none;
//   }
//   @media (min-width:$breackpoint-map) {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     width: 25%;
//     height: $map-header-height;
//     h2 {
//       font-size: 16px;
//       line-height: 1.3em;
//     }
//     p {
//       display: block;
//       font-size: 10px;
//       line-height: 1.3em;
//       margin: 10px 0 0;
//     }
//   }
// }

// .mapa-leyenda {
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   width: 100%;
//   z-index: 1003;
//   padding: 10px;
  
//   background: rgba(255, 255, 255, .5);
//   backdrop-filter: blur(10px);
//   -webkit-backdrop-filter: blur(10px);

//   border-top: 1.2px $gris solid;
//   max-height: 300px;
  
//   @media (min-width: $breackpoint-map) {
    
//     backdrop-filter: blur(10px);
//     -webkit-backdrop-filter: blur(10px);
//     max-height: inherit;
//     width: 25%;
//     bottom: 20px;
//     top: $map-header-height;
//     padding: 10px;
//     border-right: 1.2px $gris solid;
//     overflow-y: auto;
//   }

//   .row-instruccion {
//     p {
//       text-align: center;
//       font-size: 10px;
//       font-weight: 600;
//       line-height: 13px;
//       margin: 0 0 10px;
//       @media (min-width:$breackpoint-map){
//         text-align: left;
//       }
//     }
//   }

//   .leyenda-circles {
//     display: flex;
//     align-content: flex-end;
//     justify-content: space-between;
//     .circle {
//       background: #ACACAC;
//       border-radius: 50%;
//     }
//     .txt {
//       font-size: 10px;
//       line-height: 1em;
//     }
//   }
// }
// @-moz-document url-prefix() {
//   .mapa-leyenda {
//     background: linear-gradient(rgba(232,238,240,.5), rgba(255,255,255,1) 70%);
//     @media (min-width: $breackpoint-map) {
//       background: linear-gradient(-90deg, rgba(255,255,255,.7), rgba(255,255,255,1) 70%);
//     }
//   }
// }

// .mapa-notas {
//   color: #222;
//   @media (min-width:$breackpoint-map) {
//     position: relative;
//     height: 0px;
//   }
//   .summary {
//     background: #fff;
//     color: $accion;
//     text-align: center;
//     font-size: 12px;
//     padding: 4px;
//     width: 100%;
//     border-top: 1.2px $gris solid;
//     transition: all .27s ease-in-out;
//     &:hover,
//     &:focus,
//     &:active {
//       background-color: $accion;
//       color: #fff;
//     }
//     @media (min-width:$breackpoint-map) {
//       border-right: 1.2px $gris solid;
//       width: 25%;
//       position: absolute;
//       bottom: 0;
//       left: 0;
//       z-index: 1004;
//     }
//   }
//   .content {
//     max-height: 0;
//     overflow: hidden;
//     transition: all .33s ease-in-out;
//     padding: 0 15px;
//     font-size: 10px;
//     line-height: 1.3em;
//     @media (min-width:$breackpoint-map) {
//       border-left: 1.2px $gris solid;
//       border-right: 1.2px $gris solid;
//       border-bottom: 1.2px $gris solid;
//       background: #fff;
//       font-size: 12px;
//       position: absolute;
//       bottom: -1px;
//       left: calc(25% - 1px);
//       width: calc(75% - 30px);
//       z-index: 1004;
//     }
//   }
//   &.open {
//     height: auto;
//     .content{
//       max-height: 200px;
//       padding: 5px 15px;
//       @media (min-width:$breackpoint-map) {
//         border-top: 1.2px $gris solid;
//       }
//     }
//   }
// }

// .mapa-controles {
//   position: absolute;
//   bottom: 245px;
//   left: 10px;
//   z-index: 1002;
//   @media (min-width:$breackpoint-map){
//     left: calc(25% + 10px);
//     bottom: 10px;
//   }
//   .button-zoom-pais {
//     padding: 0;
//     width: 34px;
//     height: 34px;
//     img {
//       display: block;
//       width: 50px;
//       max-width: 50px !important;
//       height: 50px;
//       margin: -6px -8px;
//     }
//   }
// }


// .leaflet-map {
//   width: 100%;
//   height: 100%;
// }

// .indicador-tooltip {
//   height: 12px;
//   width: 12px;
//   border-radius: 50%;
//   border-color: #707070;
//   display: inline-block;
//   margin-right: 5px;
//   border-style: solid;
//   border-width: 0.3px;
//   margin-bottom: -2px;
//   margin-top: 3px;
// }

// .leaflet-top {
//   top: 3.5rem;
// }
// @media (min-width:1024px){
//   .leaflet-top {
//     top: 5px;
//   }
// }

// // .leaflet-bar a,
// // .leaflet-bar a:hover,
// // .leaflet-bar a:focus {
// //   color: #fff;
// //   margin-bottom: 10px;
// // }
// .card-cultivos {
//   .leaflet-bar a {
//     background: $color_tarjeta_cultivos; 
//     &:hover,
//     &:focus {
//       background: darken($color_tarjeta_cultivos, 7);
//       box-shadow: 0 0 0 4px rgba($color_tarjeta_cultivos,.2);
//     }
//   }
// }
// .card-maquinaria {
//   .leaflet-bar a {
//     background-color: $color_tarjeta_maquinaria;
//     &:hover,
//     &:focus {
//       background: darken($color_tarjeta_maquinaria, 7);
//       box-shadow: 0 0 0 4px rgba($color_tarjeta_maquinaria,.2);
//     }
//   }
// }
// .card-herbicidas {
//   .leaflet-bar a {
//     background-color: $color_tarjeta_herbicidas;
//     &:hover,
//     &:focus {
//       background: darken($color_tarjeta_herbicidas, 7);
//       box-shadow: 0 0 0 4px rgba($color_tarjeta_herbicidas,.2);
//     }
//   }
// }

// .leaflet-touch .leaflet-control-layers, .leaflet-touch .leaflet-bar {
//   border: none !important;
//   background-clip: padding-box;
// }
</style>